import { render } from "./PathButton.vue?vue&type=template&id=4614eee2&scoped=true"
import script from "./PathButton.vue?vue&type=script&lang=js"
export * from "./PathButton.vue?vue&type=script&lang=js"

import "./PathButton.vue?vue&type=style&index=0&id=4614eee2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4614eee2"]])

export default __exports__